import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiHolder, apis, api, WaFrameworkVersion } from 'api';
import { WAIMAO_PRODUCT_VERSIONS } from '@web-common/conf/waimao/constant';
const fieldSettingApi = apiHolder.api.requireLogicalApi(apis.fieldSettingApiImpl);
const roleApi = apiHolder.api.requireLogicalApi(apis.edmRoleApiImpl);
const whatsAppApi = api.requireLogicalApi(apis.insertWhatsAppApiImpl);
const initState = {
    videoDrawerProp: { visible: false, videoId: '', source: '', scene: '', forceRenderInBody: false },
    systemVariableList: undefined,
    customVariableList: undefined,
    variableListLoading: false,
    showAIAssistance: undefined,
    aiAssistanceVisible: false,
    waFrameworkVersion: undefined,
};
const REDUCER_NAME_SPACE = 'configReducer';
export const getVariableSystemListAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/getWAIMAO_PRODUCT_VERSIONS.WEBSITEVariableSystemListV2`, async (autoRec) => {
    const res = await fieldSettingApi.getVariableSystemListV2(autoRec);
    return res;
});
export const getVariableListAsync = createAsyncThunk(`${REDUCER_NAME_SPACE}/getVariableList`, async () => {
    const res = await fieldSettingApi.getVariableList();
    return res;
});
export const getAiFloatEntrance = createAsyncThunk(`${REDUCER_NAME_SPACE}/getAiFloatEntrance`, async (_, { getState }) => {
    const rootState = getState();
    if (rootState.privilegeReducer.version === WAIMAO_PRODUCT_VERSIONS.WEBSITE) {
        return false;
    }
    if (rootState.configReducer.showAIAssistance !== undefined) {
        return rootState.configReducer.showAIAssistance;
    }
    const res = await roleApi.aiFloatEntrance();
    return (res === null || res === void 0 ? void 0 : res.showAIAssistance) || false;
});
export const getWaFrameworkVersion = createAsyncThunk(`${REDUCER_NAME_SPACE}/getWaFrameworkVersion`, async (_, { getState }) => {
    const rootState = getState();
    if (rootState.configReducer.waFrameworkVersion !== undefined) {
        return rootState.configReducer.waFrameworkVersion;
    }
    const res = await whatsAppApi.getWaFrameworkVersion();
    return res;
});
const configSlice = createSlice({
    name: REDUCER_NAME_SPACE,
    initialState: initState,
    reducers: {
        showVideoDrawer: (state, action) => {
            state.videoDrawerProp = Object.assign(Object.assign({}, action.payload), { visible: true });
        },
        closeVideoDrawer: state => {
            state.videoDrawerProp = Object.assign(Object.assign({}, state.videoDrawerProp), { visible: false });
        },
        resetVideoDrawer: state => {
            state.videoDrawerProp = { visible: false, videoId: '', source: '', scene: '' };
        },
        doSetSystemVariableList: (state, action) => {
            if (action.payload) {
                state.systemVariableList = action.payload;
            }
        },
        doSetAiAssistanceVisible: (state, action) => {
            state.aiAssistanceVisible = action.payload;
        },
    },
    extraReducers: builder => {
        builder
            .addCase(getVariableSystemListAsync.pending, state => {
            state.variableListLoading = true;
        })
            .addCase(getVariableSystemListAsync.fulfilled, (state, action) => {
            state.variableListLoading = false;
            if (!action.payload)
                return;
            state.systemVariableList = action.payload;
        })
            .addCase(getVariableSystemListAsync.rejected, state => {
            state.variableListLoading = false;
        })
            .addCase(getVariableListAsync.pending, state => {
            state.variableListLoading = true;
        })
            .addCase(getVariableListAsync.fulfilled, (state, action) => {
            state.variableListLoading = false;
            if (!action.payload)
                return;
            state.customVariableList = action.payload;
        })
            .addCase(getVariableListAsync.rejected, state => {
            state.variableListLoading = false;
        })
            .addCase(getAiFloatEntrance.fulfilled, (state, action) => {
            state.showAIAssistance = action.payload;
        })
            .addCase(getWaFrameworkVersion.fulfilled, (state, action) => {
            state.waFrameworkVersion = action.payload || WaFrameworkVersion.waWebJs;
        })
            .addCase(getWaFrameworkVersion.rejected, state => {
            state.waFrameworkVersion = WaFrameworkVersion.waWebJs;
        });
    },
});
export const { actions } = configSlice;
export default configSlice.reducer;
